export default __webpack_public_path__ + "static/member3-f69f405815b2d7b81a62ec97752d202b.jpg";